import type { FC } from 'react';

import { IconContainer } from './styled';

import { CardContainer } from '../../../CardContainer';
import { Icon, IconName } from '../../../Icon';

export enum StatusInfoTypes {
    SUCCESS,
    ERROR,
}

interface IStatusInfoModalProps {
    type: StatusInfoTypes;
    className?: string;
}

export const StatusInfoModal: FC<IStatusInfoModalProps> = ({
    type,
    children,
    className,
}) => (
    <CardContainer className={className}>
        <IconContainer type={type}>
            {type === StatusInfoTypes.SUCCESS && (
                <Icon iconName={IconName.CHECKMARK} />
            )}
            {type === StatusInfoTypes.ERROR && (
                <Icon iconName={IconName.CLOSE} />
            )}
        </IconContainer>
        {children}
    </CardContainer>
);

StatusInfoModal.defaultProps = {
    className: '',
};
